import { InstanceDataConfig } from "charts/src/types/chart";

import { CustomizeCharts } from "../data/chart-configs";
import { revenueBreakdownChartInstanceDataConfig } from "./custom-converter/revenue-breakdown-chart";
import { chartTypeOverylaySorter } from "./shared";
import { ConverterInput } from "./types";

export const apiDataToInstanceDataConfig = (
  inputParams: ConverterInput
): InstanceDataConfig[] => {
  const { chartConfigDetails, chartId } = inputParams;

  if (chartId === CustomizeCharts.revenueBreakdownChart.id) {
    return revenueBreakdownChartInstanceDataConfig(inputParams);
  }

  return chartConfigDetails.chartDatas
    .map(({ valueFormatType, chartType, axis, groupType, unit }) => {
      return {
        valueFormatType,
        chartType,
        groupType,
        yAxisID: axis,
        unit: unit ?? undefined,
        unitAxisType: "top" as const,
        // unitAxisType: "side" as const,
      };
    })
    .sort(chartTypeOverylaySorter);
};
